import React, {useContext, useState, useEffect} from 'react'
import {uiContext} from '../../../components/common'
import { HeaderAdmin } from "../../components/HeaderAdmin/HeaderAdmin";
import { LateralMenu } from "../../components/LateralMenu/LateralMenu";
import { Link, useHistory } from 'react-router-dom';
import {API} from '../../../services/api'
import './RegisterStaff.scss'

export function RegisterStaffPage() {
  /**
   * Vista de registro de administrador
   * Hay un formulario que pide el email y el name al servidor
   */

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const uicontext = useContext(uiContext);
  const history = useHistory();

  const protectedRoute = ()=>{
    const sessionToken = localStorage.getItem('sessionToken');
    if(!sessionToken){
      history.push('/staff-login')
    }
  }

  const register = ()=>{
    if(window.confirm('Registrar usuario?')){
      uicontext.showLoader();
      /**
       * Registrar administrador
       * Llamar al ser
       */
      API.postRegisterStaffUser(email, name)
        .then(x => {
          uicontext.hideLoader();
          history.push('/admin/staff-list')
        })
        .catch(x => {
          alert('Error registrando usuario');
          uicontext.hideLoader();
        });
    }
  }

  useEffect(()=>{
    protectedRoute();
  },[]);

  return (
    <>
      <HeaderAdmin />
      <LateralMenu />
      <main className="content">
        <h2>Registrar Usuario</h2>
        <Link 
          to={{pathname:'staff-list'}}
          className='button-back'>Volver A Lista De Usuario</Link>
        <div className="card">
          <p>Nombre</p>
          <input type="text" onChange={(e) => setName(e.target.value)} value={name}/>
          <p>Email</p>
          <input type="text" onChange={(e) => setEmail(e.target.value)} value={email}/>
          <button 
          className="button-register" 
          onClick={()=>register()}>Registrar lead</button>
        </div>
      </main>
    </>
  )
}
